export default __webpack_public_path__ + "static/media/fastener-placement-rectangle-2-breaks.fedfe678.webp";